import { defineStore } from 'pinia';

export const useVariantPopupStore = defineStore('variantPopup', {
    state: () => ({
        openCount: 0,
    }),
    actions: {
        increment() {
            this.openCount++;
        },
        decrement() {
            if (this.openCount > 0) this.openCount--;
        },
        reset() {
            this.openCount = 0;
        },
    },
});
